import type { TRunningTests } from '../types/running-tests-config';
import { VARIANTS_PROPS_NAME } from './../constants';
import { createContext } from 'react';

type ABTestContextValue = { [VARIANTS_PROPS_NAME]: Partial<TRunningTests> };

export const ABTestContext = createContext({} as ABTestContextValue);
